@if (view(); as view) {
  <button
    class="menu-item"
    data-testid="item"
    title=""
    [matTooltipPosition]="expanded() ? 'right' : 'below'"
    [class.expanded]="expanded()"
    [class.active]="(activeView() === view || active() || hasActiveChild()) && canHighlight()"
    [class.dim-active]="(activeView() === view || active() || hasActiveChild()) && isDimHighlight()"
    [class.faded]="faded()"
    [class.primary]="primary()"
    [class.has-children]="children().length"
    [matTooltip]="itemTooltip() ?? ''"
    [disabled]="disabled()"
    (click)="navigate()"
  >
    <div class="content">
      <span class="content-main">
        <ng-container *ngTemplateOutlet="menuIcon" />
        @if (warning() && expanded()) {
          <mat-icon>warning</mat-icon>
        }
        @if (expanded()) {
          <span class="label-text">{{ label() }}</span>
        }
      </span>
      <ng-container *ngTemplateOutlet="badgeTemplate" />
    </div>
  </button>
  <ng-container *ngTemplateOutlet="content" />
}
@if (link(); as link) {
  <a
    #rla="routerLinkActive"
    class="menu-item"
    data-testid="item"
    title=""
    matTooltipPosition="right"
    routerLinkActive
    [routerLink]="link"
    [routerLinkActiveOptions]="linkActiveOptions()"
    [class.active]="(rla.isActive || active()) && canHighlight()"
    [class.dim-active]="(rla.isActive || active()) && isDimHighlight()"
    [fragment]="fragment()"
    [class.primary]="primary()"
    [matTooltip]="itemTooltip() ?? ''"
  >
    <span class="content">
      <span class="content-main">
        <ng-container *ngTemplateOutlet="menuIcon" />
        @if (expanded()) {
          <span class="label-text">{{ label() }}</span>
        }
      </span>
      <ng-container *ngTemplateOutlet="badgeTemplate" />
    </span>
  </a>
  <ng-container *ngTemplateOutlet="content" />
}
@if (!link() && !view()) {
  <button
    class="menu-item"
    data-testid="item"
    title=""
    matTooltipPosition="right"
    [disabled]="disabled()"
    [class.primary]="primary()"
    [class.disabled]="disabled()"
    [matTooltip]="itemTooltip() ?? ''"
  >
    <div class="content">
      <span class="content-main">
        <ng-container *ngTemplateOutlet="menuIcon" />
        @if (expanded()) {
          <span class="label-text">{{ label() }}</span>
        }
      </span>
      <ng-container *ngTemplateOutlet="badgeTemplate" />
    </div>
  </button>
  <ng-container *ngTemplateOutlet="content" />
}

<ng-template #content>
  @if (children().length && showChildren()) {
    <div class="children">
      <ng-content />
    </div>
  }
</ng-template>

<ng-template #menuIcon>
  @if (icon(); as icon) {
    @if (isIconName(icon)) {
      <div class="icon-container">
        @if (outlined()) {
          <mat-icon
            class="icon outlined-icon"
            fontSet="material-symbols-outlined"
          >
            {{ icon }}
          </mat-icon>
        } @else {
          <mat-icon class="icon">
            {{ icon }}
          </mat-icon>
        }
        @if (error() && !expanded()) {
          <div class="error">
            <mat-icon class="error-icon">warning</mat-icon>
          </div>
        }
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="icon" />
    }
  }
</ng-template>

<ng-template #badgeTemplate>
  @if (badge() !== null) {
    <procure-number-badge
      class="menu-item-badge"
      [value]="badge() ?? 0"
      [small]="true"
      [clickable]="false"
      [color]="badgeColor()"
    />
  } @else if (error() && expanded()) {
    <div class="error standalone">
      <mat-icon class="error-icon">warning</mat-icon>
    </div>
  }
</ng-template>
